const PREFIX = 'suitescanner-trips:';

export function readTripsCache(email: string): Wire.OrderSummary[] | null {
  try {
    const raw = window.sessionStorage.getItem(`${PREFIX}${email.toLowerCase()}`);
    if (!raw) return null;
    const value = JSON.parse(raw) as unknown;
    return Array.isArray(value) ? value as Wire.OrderSummary[] : null;
  } catch {
    return null;
  }
}

export function writeTripsCache(email: string, trips: Wire.OrderSummary[]): void {
  try {
    window.sessionStorage.setItem(`${PREFIX}${email.toLowerCase()}`, JSON.stringify(trips));
  } catch {
    // Private browsing or a full storage quota should not block bookings.
  }
}
